import React from 'react';
import PropTypes from 'prop-types';


const RewardItem = ({data, title, toggleItem}) => {
    const {name, images} = data;
    const onToggle = () => {
        toggleItem(data)
    }
    return (
        <div className="reward-item">
            <div className="item-title">{title}</div>
            <div className="item" onClick={onToggle}>
                <img src={images[0].thumbnail} alt={name} />
            </div>
        </div>
    )
}

RewardItem.propTypes = {
    data: PropTypes.shape(),
    title: PropTypes.string,
    toggleItem: PropTypes.func
}

export default RewardItem
